import React from 'react';

import { CheckBox } from '@/components/Popups/Card/Checkbox/Checkbox';
import { useSteps } from '@/components/Popups/context';
import StepsBall from '@/components/Popups/StepsBall/StepsBall';

import { ICard } from '../types';

import {
  Button,
  ButtonContainer,
  CardContent,
  CardTitle,
  Container,
  Description,
  Image,
  ImageContainer,
  Section,
  Title,
} from './style';

const Desktop = ({ title, image, card }: ICard) => {
  const { options, filterButtons, handleNextStep, handlePrevStep, handleFinish } = useSteps();

  return (
    <Container>
      <ImageContainer>
        {image && <Image>{image}</Image>}
        <StepsBall />
      </ImageContainer>

      <Section>
        {title && <Title>{title}</Title>}
        <CardContent>
          <CardTitle>{card?.title}</CardTitle>
          <Description>{card.description}</Description>
          <ButtonContainer>
            {filterButtons?.map((auxButton) => (
              <Button
                type="button"
                key={auxButton.text}
                whileTap={{ scale: 0.9 }}
                variant={auxButton?.style}
                onClick={() =>
                  auxButton?.onClick({
                    finish: handleFinish,
                    nextStep: handleNextStep,
                    prevStep: handlePrevStep,
                  })
                }
              >
                {auxButton?.text}
              </Button>
            ))}
          </ButtonContainer>

          {options?.showNotShowAgainCheckbox?.is && <CheckBox />}
        </CardContent>
      </Section>
    </Container>
  );
};

export default Desktop;
